module.exports = __webpack_public_path__ + "static/media/9.b1e20605.jpg";